/* eslint-disable no-unused-vars */

/**
 * @fileOverview F-elec main JS
 * @author Selectra Front End Team
 * @version 1.0.0
 */


//
// Imports
//

import '@babel/runtime/regenerator/'
import appLoader from 'integration-common-files/src/js/00-utilities/app-loader';

import Collapse from 'integration-common-files/src/js/02-molecules/collapse';
import displayDynamicCallBlocks from 'integration-common-files/src/js/03-organisms/call-block';
import fontsLoad from 'integration-common-files/src/js/00-utilities/fonts-load';
import initAllDropdowns from 'integration-common-files/src/js/01-atoms/dropdown/DropdownManager';
import initCookieCompliance from 'integration-app-config/src/js/03-organisms/cookie-compliance/cookie-compliance';
import initFooter from 'integration-app-config/src/js/03-organisms/footer/footer';
import initMarquee from 'integration-common-files/src/js/02-molecules/marquee';
import initMenu from 'integration-app-config/src/js/03-organisms/menu/menu';
import loadLazyLoading from 'integration-common-files/src/js/00-utilities/lazy-loading';
import loadTooltips from 'integration-common-files/src/js/01-atoms/tooltip';
import Slider from 'integration-common-files/src/js/03-organisms/carousel/slider';
import youtubeEmbed from 'integration-common-files/src/js/00-utilities/youtube-embed';


//
// Core
//

function app() {

  // Font load
  fontsLoad();

  // Tooltip
  loadTooltips();

  // Marquee
  initMarquee({
    marqueeId: 'brands-marquee'
  });

  // Collapse
  new Collapse();

  // Dropdown
  initAllDropdowns();

  // Youtube embed
  youtubeEmbed();

  // Lazy loading
  loadLazyLoading();

  // Call blocks
  displayDynamicCallBlocks()
    .then( ccStatus => {
      console.log( ccStatus );
    })
    .catch( error => {
      console.log( error );
    });

  // Menu
  initMenu();

  // Footer
  initFooter();

  // Cookie compliance
  initCookieCompliance();

  // Reviews carousel
  new Slider({
    selector: '#ac-reviews-carousel',
    responsive: {
      0: {
        controls: false
      },
      992: {
        controls: true,
        controlsAbsolute: true,
        nav: false
      }
    }
  });
}

// App loader
appLoader({
  appCode: app,
  polyfillUrls: {
    full: './js/polyfill/polyfill-full.min.js',
    partial: './js/polyfill/polyfill-partial.min.js'
  }
});
